const ENVELOPES = {
    COLLECTION: {
        url: '/posRemoteDownloads',
        queryKey: 'getPosRemoteDownloads'
    },
    FILE_ACTION: {
        url: '/posRemoteDownloads/fileAction'
    },
    EXPORT: {
        url: '/posRemoteDownloads/export'
    },
    CREATE: {
        url: '/posRemoteDownloads'
    },
    DEPROGRAM: {
        url: '/posRemoteDownloads'
    }
};

const DOWNLOAD_CODES = {
    COLLECTION: {
        url: '/posRemoteDownloadsCodes',
        queryKey: 'getPosRemoteDownloadCodes'

    },
    CREATE: {
        url: '/posRemoteDownloadsCodes'
    },
    UPDATE: {
        url: '/posRemoteDownloadsCodes/:downloadCodeUuid'
    }
};

export { ENVELOPES, DOWNLOAD_CODES };